import { Box, Tab, Tabs } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { setMCUTab } from 'store/mcuSlice';
import { color } from 'theme';

export default function TabMCUControl({ t, setCurrentPage }) {
    const { searchQuery, isDetailed} = useSelector((state) => state.mcu);

    const dispatch = useDispatch();

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const handleChangeCurrentTab = (_, tab) => {
        dispatch(setMCUTab(tab))
    }

    return (
        <Box
            sx={{
                height: '60px',
                backgroundColor: color.whiteF2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
            }}
        >
            <Tabs value={searchQuery.tab} onChange={handleChangeCurrentTab} sx={{ bgcolor: '#F2F2F2' }}>
                <Tab label={t('mcu.button.roomList')} {...a11yProps(0)} sx={{ color: theme => theme.palette.text.primary }} />
                <Tab label={isDetailed ? t('mcu.button.deviceListDetail') : t('mcu.button.deviceList')} {...a11yProps(1)} sx={{ color: theme => theme.palette.text.primary }} />
            </Tabs>
        </Box>
    );
}
